import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "@progress/kendo-theme-default/dist/all.css";
import { useMediaQuery } from "@material-ui/core";
import "./signatory-list.css";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { CheckBoxHLPure, GridSignatures, TooltipHLPure } from "..";
import { Document, Page } from "react-pdf";
import DialogOnePage from "../dialogOnePage/dialogOnePage.pure";
import { LocalStorageService } from "../../../services";
import DialogSystemGLPure from '../dialogSystemGL/dialogSystemGL.pure'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  );
};

/* ======= Grid component list of signers ======= */
const SignatoryListAutographPure = (props) => {
  const {
    signers,
    toggleDialogDeleteSigner,
    toggleLoadingRequesting,
    setStillSigning,
    stillSigning,
    currentUser,
    setCurrentUser,
    showLoadingRequesting,
    type,
    setSigners,
    validateInput,
    isAtgrafSignature,
    signatureTypeId,
    signatureTypeESignChecked,
    signatureTypeAdvancedChecked,
    signatureTypeAutographChecked,
    processTypeAprovationChecked,
    processTypeAprovationSequentialChecked,
    processTypeRandomChecked,
    processTypeSequentialChecked,
    signatures,
    setSignatures,
    deleteSignaturesByIndex,
    deleteSignatures,
    insertSignBySigner,
    showThirdProofLifeCol,
    proofLifeCheckboxId,
    booleanValue,
    proofOfLifeChecked
  } = props;

  const isShowIndex = useMediaQuery("(min-width:540px)");
  const showFourthCol = useMediaQuery('(max-width:690px)')
  const showSecondCol = useMediaQuery(showThirdProofLifeCol ? "(max-width:1160px)" : "(max-width:740px)")
  const showProofOfLifeCol = useMediaQuery("(max-width:1020px)")

  const { t } = useTranslation();
  const gridLabelNorecordsStyles = {
    color: "#828282",
    fontSize: "15px",
    fontWeight: 500,
  };
  const localStorageService = new LocalStorageService()
  const creatorEmail = localStorageService.getLocalStorageItem("user").userMetaData.userMifirma.email

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pager, setPager] = useState(1);
  const [tempImgPages, setTempImgPages] = useState({});
  const [visible, setVisible] = useState(false)
  const [userEmail, setUserEmail] = useState("")
  const [tempImgDimentions, setTempImgDimentions] = useState({ width: 0, height: 0 })
  const [showProofLifeConfirm, setShowProofLifeConfirm] = useState(false)
  const [pendingProofLifeChange, setPendingProofLifeChange] = useState(null)

  const isSurface = useMediaQuery("(max-width:1070px)");
  let padlockLocked = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_locked.svg"
  let padlickUnlocket = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_unlocked.svg"

  let pdfFile = props.pdfFile;

  const onDocumentLoadSuccess = (params) => {
    setPager(params.numPages);
    setNumPages(params.numPages);
    if (pageNumber === 0) setPageNumber(params.numPages);
  };

  const previousPage = () => {
    if (pageNumber <= 1) {
      return
    }
    setPageNumber(pageNumber - 1)
  }

  const nextPage = () => {
    if (pageNumber === numPages) {
      return
    }
    setPageNumber(pageNumber + 1)
  }

  const firstPage = () => {
    setPageNumber(1)
  }

  const lastPage = () => {
    setPageNumber(numPages)
  }

  const searchPage = (number) => {
    const namber = Number(number)
    if (namber >= numPages) {
      setPageNumber(numPages)
    } else if (namber <= 1) {
      setPageNumber(1)
    }
  }

  const setVisibleAndEmail = (props) => {
    setUserEmail(props.dataItem.email)
    setVisible(true)
  }

  const trashAutograph = (props) => (
    <td
      className="fifth-col"
    >
      {(isAtgrafSignature && signatureTypeSelected === true) ? (
        <div className="dialogContent">
          <button
            onClick={() => setVisibleAndEmail(props)}
            className="dialog-accept-signature-autograf-button-signs-details"
          >
            {isSurface ? t("documentDisplay.locate") : t("documentDisplay.locateSign")}
          </button>
          <i
            onClick={() => {
              toggleDialogDeleteSigner(props.dataItem);
            }}
            style={{ cursor: "pointer" }}
            className="k-icon k-i-delete k-i-trash"
          />
        </div>
      ) : (<i
        onClick={() => {
          toggleDialogDeleteSigner(props.dataItem);
        }}
        style={{ cursor: "pointer" }}
        className="k-icon k-i-delete k-i-trash"
      />)}
      {(visible && props.dataItem.email === userEmail && !showLoadingRequesting) &&
        <DialogOnePage
          showLoadingRequesting={showLoadingRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          dataItem={props.dataItem}
          tempImage={tempImgPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          tempImageWidth={tempImgDimentions.width}
          tempImageHeight={tempImgDimentions.height}
          nextPage={nextPage}
          previousPage={previousPage}
          firstPage={firstPage}
          lastPage={lastPage}
          signatures={signatures}
          close={() => setVisible(false)}
          numPages={numPages}
          setSigners={setSigners}
          searchPage={searchPage}
          signers={signers}
          deleteSignaturesByIndex={deleteSignaturesByIndex}
          setSignatures={setSignatures}
          insertSignaturesBySigner={insertSignBySigner}
        />
      }
    </td >
  );

  let signatureTypeSelected =
    !signatureTypeESignChecked &&
    !signatureTypeAdvancedChecked &&
    signatureTypeAutographChecked

  const onRender = async (params) => {
    const canvaImg = document.querySelector(`.import-pdf-page-${pageNumber} canvas`)
    setTempImgPages(canvaImg.toDataURL())
    setTempImgDimentions({ width: params.width, height: params.height })
    toggleLoadingRequesting(false)
  }

  const changeSendDocument = (findSigner, value) => {
    let foundSigner = signers.find(signer => signer.email === findSigner.email);
    foundSigner.sendDocument = value
    setSigners(signers)
  }


  const changeProofLife = (dataItem, e) => {
    let value = e.target.checked
    const originalNoPassword = dataItem._originalNoPassword ?? dataItem.noPasswordRequired ?? dataItem.isSignerNoPassword ?? false

    // Save the original value the first time
    if (dataItem._originalNoPassword === undefined) {
      dataItem._originalNoPassword = originalNoPassword
    }

    if (value && originalNoPassword) {
      setPendingProofLifeChange({ dataItem, value })
      setShowProofLifeConfirm(true)
      return
    }

    if (proofLifeCheckboxId === 'proofOfLife') {
      dataItem.proofOfLife = value
      dataItem.faceRecognition = false
    } else {
      dataItem.faceRecognition = value
      dataItem.proofOfLife = false
    }

    // If proof of life is unchecked and the user originally had passwordless access, restore it
    if (!value && dataItem._originalNoPassword) {
      dataItem.isSignerNoPassword = true
      dataItem.noPasswordRequired = true
    }

    setSigners(signers)
  }

  const handleConfirmProofLife = () => {
    if (!pendingProofLifeChange) return

    const { dataItem, value } = pendingProofLifeChange

    if (proofLifeCheckboxId === 'proofOfLife') {
      dataItem.proofOfLife = value
      dataItem.faceRecognition = false
    } else {
      dataItem.faceRecognition = value
      dataItem.proofOfLife = false
    }

    // If proof of life is activated, disable passwordless (requires login)
    if (value === true) {
      dataItem.isSignerNoPassword = false
      dataItem.noPasswordRequired = false
    }

    setSigners(signers)
    setShowProofLifeConfirm(false)
    setPendingProofLifeChange(null)
  }

  const handleCancelProofLife = () => {
    setShowProofLifeConfirm(false)
    setPendingProofLifeChange(null)
  }


  const mobileQuery = useMediaQuery("(max-width:960px)");
  const query700 = useMediaQuery("(max-width:705px)");

  const InvitedWithoutPassword = ({ dataItem }) => {
    return <td style={{ display: "flex", flexDirection: "row" }}>
      <span>
        <img src={(dataItem.isSignerNoPassword) ? padlickUnlocket : padlockLocked} className="signatoryListAutographPure-customIcon" />
      </span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>
          {isShowIndex ? dataItem.nameSigner : dataItem.nameSigner.split(" ")[0]}
        </span>
        <span>{dataItem.email}
        </span>
      </div>
    </td>
  }

  const InvitedWithPassword = ({ dataItem }) => {
    return <td style={{ display: "flex", flexDirection: "column" }}>
      <span>
        {dataItem.nameSigner}
      </span>
      <span>
        {dataItem.email}
      </span>
    </td>
  }

  const CheckboxSendDocuments = ({ dataItem }) => {
    return <td>
      <CheckBoxHLPure
        disabled={creatorEmail === dataItem.email}
        valueCheckBox={dataItem.sendDocument}
        checkedState={dataItem.sendDocument}
        onChangeHandler={(e) => changeSendDocument(dataItem, e.target.checked)}
      />
    </td>
  }

  const CheckboxNoPassword = ({ dataItem }) => {
    const noPasswordValue = dataItem.noPasswordRequired ?? dataItem.isSignerNoPassword ?? false
    return <td>
      <CheckBoxHLPure
        disabled={true}
        valueCheckBox={noPasswordValue}
        checkedState={noPasswordValue}
        onChangeHandler={() => { }}
      />
    </td>
  }

  const CheckboxProofLife = ({ dataItem }) => {
    return <td className="proofOfLife-column">
      <CheckBoxHLPure
        valueCheckBox={(proofLifeCheckboxId === 'proofOfLife') ? dataItem.proofOfLife : dataItem.faceRecognition}
        checkedState={(proofLifeCheckboxId === 'proofOfLife') ? dataItem.proofOfLife : dataItem.faceRecognition}
        onChangeHandler={(e) => changeProofLife(dataItem, e)}
      />
    </td>
  }

  const headerStyles = {
    color: "#2c353c",
    fontfamily: "Quicksand",
    fontSize: 14,
    margin: "-16px -24px",
    padding: "16px 24px",
    fontWeight: 700,
    lineHeight: "inherit",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    outline: 0,
    cursor: "pointer",
  }

  return (
    <div>
      <GridSignatures
        dataGrid={signers}
        firstField="nameCompleted"
        firstTitle={t("newSignatureDetailView.column.name")}
        firstCustomCell={({ dataItem }) => {
          const noPasswordValue = dataItem.noPasswordRequired ?? dataItem.isSignerNoPassword ?? false
          return (dataItem.type !== 4) ? <td
            style={{ display: "flex", flexDirection: "row" }}>
            <div className="signatoryListAutographPure-tooltip">
              <TooltipHLPure
                positionTooltip="right"
                titleTooltip={noPasswordValue ? t("signatureRequest.profile-title-without-password") : t("signatureRequest.profile-title-with-password")}
                descriptionTooltip={noPasswordValue ? t("signatureRequest.profile-tooltip-without-password") : t("signatureRequest.profile-tooltip-with-password")}
                customImg={noPasswordValue ? padlickUnlocket : padlockLocked}
                styleCustomImg="signatoryListAutographPure-customIcon"
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", marginTop: '10px' }}>
              <span style={{ fontWeight: 700, marginBottom: '2px' }}>
                {isShowIndex ? dataItem.nameCompleted : dataItem.nameSigner.split(" ")[0]}
              </span>
              <span>
                {dataItem.email}
              </span>
            </div>
          </td> : <td style={{ display: "flex", flexDirection: "column", marginTop: '10px' }}><span style={{ fontWeight: 700, marginBottom: '2px' }}>{dataItem.nameCompleted}</span><span>{dataItem.email}</span></td>
        }}
        showSecondCol={!showSecondCol}
        secondField={(isAtgrafSignature && signatureTypeSelected) ? "numSign" : null}
        secondTitle={!query700 ? t("newSignatureDetailView.signatoriesQuantity.title") : null}
        secondHeaderCell={!query700 ? ({ title }) => (
          <span style={{ fontWeight: 700, fontSize: 14, color: '#2c353c', whiteSpace: 'normal', wordBreak: 'break-word', display: 'block', lineHeight: '1.3' }}>
            {title}
          </span>
        ) : undefined}
        secondHeaderClassname={"second-header"}
        // secondColWidth={mobileQuery ? 100 : 150}
        secondColWidth={90}
        secondColClassname={"second-col"}
        showFifthCol
        showFourthCol={(type !== "validators") ? (!showFourthCol) ? true : false : false}
        fourthTitle={t("signatureRequest.sendDocs.title")}
        fourthColWidth={150}
        fourthCell={({ dataItem }) => <CheckboxSendDocuments dataItem={dataItem} />}
        fourthHeaderCell={() => <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <a style={headerStyles}>
            {t("signatureRequest.sendDocs.title")}
          </a>
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={t("signatureRequest.sendDocs.title")}
            descriptionTooltip={t("signatureRequest.sendDocs.tooltip")}
            informationIcon
          />
        </div>
        }
        showSixthCol={(() => {
          const base = (type !== "validators" && signatureTypeAutographChecked) ? (!showFourthCol) ? true : false : false
          if (!base) return false
          if (proofOfLifeChecked) return false
          if (booleanValue === "" || booleanValue === null || booleanValue === undefined || booleanValue === false) {
            return false
          }
          if (booleanValue === true) {
            return true
          }
          return false
        })()}
        sixthTitle={t("signatureRequest.noPassword.title")}
        sixthColWidth={150}
        sixthCell={({ dataItem }) => <CheckboxNoPassword dataItem={dataItem} />}
        sixthHeaderCell={() => <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <a style={headerStyles}>
            {t("signatureRequest.noPassword.title")}
          </a>
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={t("signatureRequest.noPassword.title")}
            descriptionTooltip={t("signatureRequest.noPassword.tooltip")}
            informationIcon
          />
        </div>
        }
        fifthTitle={t("newSignatureDetailView.column.actions")}
        fifthFieldCell={trashAutograph}
        // fifthColWidth={!isSurface ? 125 : 150}
        fifthColClassname={"fifth-col"}
        noResultsText={type === "validators" ? "No se han agregado autorizadores" : "No se han agregado firmantes"}
        showThirdProofLifeCol={showThirdProofLifeCol && !showProofOfLifeCol}
        ThirdProofLifeColWidth={mobileQuery ? 100 : 150}
        ThirdProofLifeColHeaderClassname={"proofOfLife-header"}
        ThirdProofLifeColHeaderCell={() => <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <a style={headerStyles}>
            {props.titleProofLifeCol}
          </a>
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={props.titleProofLifeCol}
            descriptionTooltip={"Para cada firmante, activa la casilla de verificación si deseas solicitar prueba de vida"}
            informationIcon
          />
        </div>}
        ThirdProofLifeColClassname={"proofOfLife-column"}
        ThirdProofLifeColTitle={props.titleProofLifeCol}
        ThirdProofLifeColField={props.ThirdProofLifeColField}
        ThirdProofLifeColCell={({ dataItem }) => <CheckboxProofLife dataItem={dataItem} />}
      />
      <div
        style={{ display: "none" }}
      >
        <Document
          file={pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(e) => console.log(e, "Error pdf")}
        >
          <Page
            className={`import-pdf-page-${pageNumber}`}
            pageNumber={pageNumber}
            onRenderSuccess={(params) => onRender(params)}
          />
        </Document>
      </div>
      <DialogSystemGLPure
        showConfirm={showProofLifeConfirm}
        confirmTitle={t('dialogSystemGLPure.proofLifeLoginRequired.title')}
        confirmMessage={t('dialogSystemGLPure.proofLifeLoginRequired.message', {
          email: pendingProofLifeChange?.dataItem?.email || ''
        })}
        handleConfirmDeleteFlowClose={handleCancelProofLife}
        handleConfirmDeleteFlowSubmit={handleConfirmProofLife}
        labelCancelConfirmation={t('dialogSystemGLPure.proofLifeLoginRequired.cancel')}
        labelSubmitConfirmation={t('dialogSystemGLPure.proofLifeLoginRequired.confirm')}
      />
    </div>
  );
};

export { SignatoryListAutographPure as default };